<template>
                  <v-card  :loading="childAddStatus===1">
                    <v-card-title>
                      <span class="headline">Import danych</span>
                      <v-spacer />
                      <v-chip v-if="fileContentErrors.length>0" outlined small label color="error">{{fileContentErrors[0]}}</v-chip>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        
                          <v-row dense>                   
                           <v-col cols="12">
                              <v-file-input
                                clearable
                                v-model="file"
                                label="Wybierz plik XLSX"
                              ></v-file-input>
                            </v-col>
                         
                          </v-row>
                        
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray" text @click="close">Anuluj</v-btn>
                      <v-btn color="primary darken-1" text @click="handleSubmit" >Importuj</v-btn>
                    </v-card-actions>
                  </v-card>
</template>

<script>
  import XLSX from 'xlsx'
  import required from 'vuelidate/lib/validators/required'

  export default {
    components:{

},
    data: () => ({
       file: null,
       fileWithHeader:true,
       fileContent:null
    }),
    validations: {
      fileContent: {
          required,
        },
    },
    watch: {
      file(val) {
        if (!val) {
          this.fileContent = null;
        } else {
          //this.createBase64File(val);
          //this.fileContent = val.name;
          this.handleFile(val)
        }
    },
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      childAddStatus(){
        return this.$store.getters.getChildAddStatus();
      },
      childAddText(){
        return this.$store.getters.getChildAddText;
      },
    
      fileContentErrors () {
        const errors = []
        if (!this.$v.fileContent.$dirty) return errors
        !this.$v.fileContent.required && errors.push('Plik jest wymagany')
        return errors
      },
    },
 
    methods: {
      handleFile(file) {
       
        const reader = new FileReader();
        reader.onload = e => {
            let binary = "";
            const bytes = new Uint8Array(e.target.result);
            const length = bytes.byteLength;
            for (var i = 0; i < length; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            var workbook = XLSX.read(binary, {
                type: "binary", sheetRows: 0
            });

            this.fileContent = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]],{ header: 0, blankrows: false })
         
        };
        reader.onerror = e => {
            console.log(e);
        };
        reader.readAsArrayBuffer(file);
    },
      close(){
        //this.$v.$reset();
        this.$emit('close');
      },
       handleSubmit () {
        this.$v.$touch()
        if (this.$v.$invalid) {

        } else {
            // if (this.itemEditing) {
              this.$store.dispatch( 'importChildren', {
                children: this.fileContent
              });
            // }
        }
      },
    },
  }
</script>

